import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const SolidMoreIcon = ({
  fill,
  ...rest
}: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 12 16" {...rest} fill={fill ?? '#677383'}>
      <circle cx="7.9999" cy="8.0001" r="1.6" fill="inherit" />
      <circle cx="7.9999" cy="14.4" r="1.6" fill="inherit" />
      <circle cx="7.9999" cy="1.59995" r="1.6" fill="inherit" />
    </SvgWrapper>
  );
};
